<template>
  <div class="users-list" :class="{ '-show': show }">
    <div @click="toggleShow" class="l-header">
      <h4>Сотрудники</h4>
    </div>
    <slot name="counters"></slot>
    <div v-if="!loading && users.length" class="l-body">
      <div
        @click="selectUser(u, i)"
        :key="u.id"
        v-for="(u, i) in users"
        class="-user"
        :class="{ '-selected': u.selected }"
      >
        {{ userName(u.email) }}
      </div>
    </div>
    <div class="filter">
      <slot name="roles"></slot>
      <slot name="directions"></slot>
    </div>

    <div v-if="!loading && !users.length" class="l-body">
      <p class="no_data">Нет данных</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      show: false
    };
  },
  props: ["users", "loading"],
  computed: {
    ...mapGetters("app", ["resolveUser"])
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    userName(email) {
      try {
        const { first_name, last_name } = this.resolveUser(email);
        if (first_name && last_name) return `${first_name} ${last_name}`;
        else return email;
      } catch (e) {
        void e;
        return email;
      }
    },
    selectUser(user, index) {
      this.$emit("selectUser", { user, index });
    }
  }
};
</script>
